export const SET_CURRENT_USER = "@USER/SET_CURRENT_USER";
export const GET_CURRENT_USER = "@USER/GET_CURRENT_USER";

export const SET_SELECTED_PROJECT = "@USER/SET_SELECTED_PROJECT";
export const SET_SELECTED_BOT = "@USER/SET_SELECTED_BOT";
